// extracted by mini-css-extract-plugin
module.exports = {"grid":"loader_grid__CYGvv","counter":"loader_counter__db7vi","heading":"loader_heading__iCQ7L","text":"loader_text__I7NKQ","content":"loader_content__F9kUy"};